import Tooltip from "@mui/material/Tooltip";
import LockOutlinedIcon from "@mui/icons-material/LockOutlined";
import "./Withheld.scss";

/**
 * Prototype LOCK_TIPS (index_final.html): hovering a Hidden chip says what is hidden and when it appears. The second
 * sentence is there because the rest of the entry is shown.
 */
export const WITHHELD_TIPS = {
  employer: ["Where they worked", "Visible once your business is verified. The role and dates are shown in full."],
  institution: ["Where they studied", "Visible once your business is verified. The qualification and dates are shown in full."],
  resume: ["Full CV", "Available once your business is verified."],
  video: ["Intro video", "Visible once your business is verified."],
} as const;

export type WithheldTip = keyof typeof WITHHELD_TIPS;

/** PRD-3334: a withheld value renders as a "Hidden" chip. The browser never has the real value. */
function Withheld({ className = "", tip }: { className?: string; tip?: WithheldTip }) {
  const chip = (
    <span className={`hidden-chip${tip ? " hidden-chip--tip" : ""} ${className}`.trim()} aria-label="Hidden until after a call" tabIndex={tip ? 0 : undefined}>
      <LockOutlinedIcon className="hidden-chip__icon" />
      Hidden
    </span>
  );
  if (!tip) return chip;
  const [title, text] = WITHHELD_TIPS[tip];
  return (
    <Tooltip
      title={
        <>
          <b>{title}</b>
          {text}
        </>
      }
      placement="top"
      enterTouchDelay={0}
      leaveTouchDelay={4000}
      slotProps={{ tooltip: { className: "hidden-chip-tip" } }}
    >
      {chip}
    </Tooltip>
  );
}

export default Withheld;
